import React from 'react';
import { Box, Typography } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const InitialStep = () => {
  const { themeMode, currentTheme } = useOutletContext();

  return (
    <Box sx={{ padding: 2, color: themeMode === "dark" ? "#ffffff" : currentTheme?.callAutomationPage?.textColor }}>
      <Typography variant="h6" gutterBottom>
        Call Automation Setup
      </Typography>
      <Typography>
        Please configure the options on the left and click Submit.
      </Typography>
      {/* You could add other initial instructions or content here */}
    </Box>
  );
};

export default InitialStep; 